import { connect } from 'react-redux'

import TourneeModal from '../../../pages/settings/components/Modals/TourneeModal'

import {
  changeOffsetWareHouse,
  fetchWareHouses,
  fetchWareHousesMore,
  resetConfigWareHouse,
  searchWareHouses,
} from '../../../redux/simulateTournee/actions'
import {
  getIsLoadingWarehouses,
  getWarehouses,
  getWarehousesCount,
} from '../../../redux/simulateTournee/selectors'
import { createTournee, updateTournee } from '../../../redux/tournees/actions'
import {
  getErrorMessage,
  getIsLoadingTourneeAction,
  getSuccess,
} from '../../../redux/tournees/selectors'
import {
  fetchVehicules,
  getVehiculesMore,
  onSearchVehicules,
  pageChangedVehicules,
  resetVehiculeConfig,
} from '../../../redux/vehicules/actions'
import {
  getIsLoadingVehiculesList,
  getVehiculesList,
  getVehiculesListCount,
} from '../../../redux/vehicules/selectors'
import {
  getDriversSettings,
  getDriversSettingsCount,
  getDriversSettingsListIsLoading,
} from '../../../redux/driver/selectors'
import {
  fetchDrivers,
  getDriversMore,
  onAjoutSearchDriver,
  pageChangedDrivers,
  resetDriversConfig,
} from '../../../redux/driver/actions'

const mapStateToProps = (state) => ({
  isLoadingTourneeAction: getIsLoadingTourneeAction(state),
  success: getSuccess(state),
  errorMessage: getErrorMessage(state),

  drivers: getDriversSettings(state),
  driversCount: getDriversSettingsCount(state),
  isLoadingDrivers: getDriversSettingsListIsLoading(state),

  vehicules: getVehiculesList(state),
  vehiculesCount: getVehiculesListCount(state),
  isLoadingVehiculesList: getIsLoadingVehiculesList(state),

  warehouses: getWarehouses(state),
  warehousesCount: getWarehousesCount(state),
  isLoadingWarehouses: getIsLoadingWarehouses(state),
})

const mapDisptachToProps = (dispatch) => ({
  createTournee: (tournee) => dispatch(createTournee(tournee)),
  updateTournee: (newTournee, id) => dispatch(updateTournee(newTournee, id)),

  fetchDrivers: () => {
    dispatch(fetchDrivers())
  },
  searchDrivers: (search) => {
    dispatch(pageChangedDrivers(0))
    dispatch(onAjoutSearchDriver(search))
    dispatch(fetchDrivers())
  },
  fetchMoreDrivers: (offset, search) => {
    dispatch(pageChangedDrivers(offset))
    dispatch(onAjoutSearchDriver(search))
    dispatch(getDriversMore())
  },

  fetchVehicules: () => dispatch(fetchVehicules()),
  searchVehicules: (search) => {
    dispatch(onSearchVehicules(search))
    dispatch(pageChangedVehicules(0))
    dispatch(fetchVehicules())
  },
  fetchMoreVehicules: (offset, search) => {
    dispatch(pageChangedVehicules(offset))
    dispatch(onSearchVehicules(search))
    dispatch(getVehiculesMore())
  },

  resetDriver: () => dispatch(resetDriversConfig()),
  resetVehicule: () => dispatch(resetVehiculeConfig()),
  resetConfigWareHouse: () => dispatch(resetConfigWareHouse()),

  fetchWareHouses: (search) => {
    dispatch(searchWareHouses(search))
    dispatch(fetchWareHouses())
  },
  fetchWareHousesMore: (offset) => {
    dispatch(changeOffsetWareHouse(offset))
    dispatch(fetchWareHousesMore())
  },
})

export default connect(mapStateToProps, mapDisptachToProps)(TourneeModal)
